__turbopack_context__.v({
  "button": "alertsModal-module-scss-module__uk5rAW__button",
  "caption": "alertsModal-module-scss-module__uk5rAW__caption",
  "copyAll": "alertsModal-module-scss-module__uk5rAW__copyAll",
  "modal": "alertsModal-module-scss-module__uk5rAW__modal",
  "success": "alertsModal-module-scss-module__uk5rAW__success",
  "title": "alertsModal-module-scss-module__uk5rAW__title",
});
